<template>
    <modal :open="localOpen" :size="showSignupFormLocal ? 'lg' : 'md'" @close="$emit('close')" borderColor="primary" :borderSize="1">
        <template #header>
            {{ formHeader }}
        </template>
        <template #default>
            <login-signup :showLoginForm="showLoginFormLocal" :showSignupForm="showSignupFormLocal" :inline="true" :quickSignup="quickSignup" :loginText="loginText" :signupText="signupText" :instructions="instructions" :instructionsCssClass="instructionsCssClass" :signupType="signupType" :signupId="signupId" :buttonsCssClass="buttonsCssClass" @showLogin="switchToLoginForm" @showSignup="switchToSignupForm" @header="setHeader" :showHeader="false" />
        </template>
    </modal>
</template>

<script type="text/javascript">
    import LoginSignup from '@/components/Content/Auth/LoginSignup.vue';
    import CommonComponents from '@/components/Common.vue';

    import { UseAuthStore } from '@/store/Auth.js';

    export default {

        components: {
            LoginSignup,
            ...CommonComponents,
        },

        setup() {
            return {
                authStore: UseAuthStore(),
            };
        },

        data() {
            return {
                localOpen: true,

                showLoginFormLocal: true,
                showSignupFormLocal: false,
                formHeader: 'Please Login',

                loggedInUserId: null,
                
            };
        },
        
        emits: ['showLogin', 'showSignup', 'close', 'userAccount'],

        props: {
            open: {
                type: Boolean,
                default: true,
            },

            showLoginForm: {
                type: Boolean,
                default: true,
            },
            showSignupForm: {
                type: Boolean,
                default: false,
            },

            quickSignup: {
                type: Boolean,
                default: false,
            },

            loginText: {
                type: String,
                default: 'Login to Your Account',
            },

            signupText: {
                type: String,
                default: 'Create a New Account',
            },

            instructions: {
                type: String,
                default: 'In order to access this page, you need to login or create a new account.',
            },

            instructionsCssClass: {
                type: String,
            },
            
            signupType: {
                type: String,
            },

            signupId: {
                type: [String, Number],
            },
            
            buttonsCssClass: {
                type: String
            },
        },

        created() {
            this.showLoginFormLocal = this.showLoginForm;
            this.showSignupFormLocal = this.showSignupForm;
            this.localOpen = this.open;

            if (this.authStore.loggedInUser) {
                this.loggedInUserId = this.authStore.loggedInUser.id;
            }

            // we'll watch user id change
            // so we can refresh the content as needed
            this.$watch(
                () => this.authStore.loggedInUser,

                (function(newVal) {
                    if (
                        (newVal) &&
                        (newVal.id)
                    ) {
                        if (newVal.id != this.loggedInUserId) {
                            this.loggedInUserId = newVal.id;
                        }
                    }
                    else {
                        this.loggedInUserId = null;
                    }
                }.bind(this)),

                { deep: true }
            );
        },

        watch: {
            open() {
                this.localOpen = this.open;
            },

            showLoginForm(newVal) {
                this.showLoginFormLocal = newVal;
            },

            showSignupForm(newVal) {
                this.showSignupFormLocal = newVal;
            },

            loggedInUserId() {
                if (this.loggedInUserId) {
                    this.localOpen = false;
                    this.$emit('userAccount');
                }
            },
        },

        methods: {
            switchToLoginForm() {
                this.showLoginFormLocal = true;
                this.showSignupFormLocal = false;
                this.$emit('showLogin');
            },

            switchToSignupForm() {
                this.showLoginFormLocal = false;
                this.showSignupFormLocal = true;
                this.$emit('showSignup');
            },

            setHeader(header) {
                this.formHeader = header || 'Please Login';
            },
        },
    };

</script>
